// @noflow
/* eslint-env browser */

const KEY = 'referralTracking';
const PARAMS = ['source', 'campaign', 'channel'];

const clean = value => {
  const normalized =
    typeof value === 'string' ? value.trim().toLowerCase() : '';
  return /^[a-z0-9_-]{1,50}$/.test(normalized) ? normalized : '';
};

const normalizeTracking = tracking =>
  Object.fromEntries(PARAMS.map(param => [param, clean(tracking[param])]));

export const captureReferralTracking = () => {
  if (typeof window === 'undefined') return;

  try {
    const storage = window.sessionStorage;
    if (storage.getItem(KEY) !== null) return;

    // Preserve first attribution for tabs opened before this storage format.
    const legacy = clean(storage.getItem('referralSource'));
    if (legacy) {
      storage.setItem(KEY, JSON.stringify(normalizeTracking({source: legacy})));
      return;
    }

    const url = new URLSearchParams(window.location.search);
    if (!PARAMS.some(param => url.has(param))) return;

    const tracking = Object.fromEntries(
      PARAMS.map(param => [param, clean(url.get(param))])
    );
    storage.setItem(KEY, JSON.stringify(tracking));
  } catch (error) {
    // Unavailable browser storage must not interrupt login or quote creation.
  }
};

export const getReferralTracking = () => {
  const empty = normalizeTracking({});
  if (typeof window === 'undefined') return empty;

  try {
    const storage = window.sessionStorage;
    const raw = storage.getItem(KEY);
    if (raw !== null) {
      try {
        const stored = JSON.parse(raw);
        if (stored && typeof stored === 'object' && !Array.isArray(stored)) {
          return normalizeTracking(stored);
        }
      } catch (error) {
        // Fall back to legacy attribution if the saved JSON is malformed.
      }
    }
    return normalizeTracking({source: storage.getItem('referralSource')});
  } catch (error) {
    return empty;
  }
};

export const buildTrackingUrl = () => {
  const tracking = getReferralTracking();
  if (!PARAMS.some(param => tracking[param])) return '';
  return PARAMS.map(param => `${param}=${tracking[param]}`).join('&');
};
